import { GetRoomTypeModel } from "@factory/model/query-model-room-type";
import { useDateTimeContext } from "@shared/utility/date-time-service/date-time.context";

import { roomTypeFormDefault } from "./form.default";
import { RoomTypeFormSchema } from "./form.rule";

export const useFormDefaultRoomType = () => {
  const { formatDate } = useDateTimeContext();

  const getDefault = (cachedValue: GetRoomTypeModel | undefined) => {
    return !cachedValue
      ? roomTypeFormDefault
     : ({
        hotel: cachedValue.hotel,
        validFrom: cachedValue.valid_from,
        validUntil: cachedValue.valid_until,
        name: cachedValue.name,
        price: cachedValue.price,
      } as RoomTypeFormSchema);
  };

  return {
    getDefault,
  };
};
